import { MOCK_FORM_COUNT } from '../constants/mockForms';
import { l2ReadyMockCount, l3ReadyMockCount } from './bankMeta';

export const WEAKEST_TOPIC_MIN_QUESTIONS = 5;

/** Exact ratios first; ties use sample size then name, independent of bank order. */
export function weakestOfferTopics(rows = []) {
  return rows.filter(r => r.name && r.name !== 'Other' && r.total >= WEAKEST_TOPIC_MIN_QUESTIONS &&
    Number.isFinite(r.correct) && r.correct >= 0 && r.correct <= r.total)
    .slice().sort((a, b) => a.correct / a.total - b.correct / b.total || b.total - a.total || a.name.localeCompare(b.name))
    .slice(0, 3);
}

export function resultsMockCount(level) {
  return level === 'l3' ? l3ReadyMockCount() : level === 'l2' ? l2ReadyMockCount() : MOCK_FORM_COUNT;
}

export function resultsCoverageLine(level) {
  const count = resultsMockCount(level);
  return `Mock Exams 2–${count} add ${count - 1} more full-length Mock Exams for Level ${level === 'l3' ? 3 : level === 'l2' ? 2 : 1}.`;
}
